import React from 'react';
import { LockIcon, CreditCardIcon, ZapIcon, CheckIcon } from 'lucide-react';
import { PricingCard } from './PricingCard';
import { CheckEmoji, LightningEmoji } from './Emoji';
import { handleCheckout } from './CheckoutUtils';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-29">
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="max-w-3xl mx-auto text-center" data-id="element-31">
          <PricingCard data-id="element-32" />
          {/* Lo Mejor de Todo Section */}
          <div className="mt-12 bg-amber-50 border border-amber-200 rounded-xl p-8 shadow-sm" data-id="element-33">
            <h3 className="text-2xl font-bold text-amber-800 mb-4" data-id="element-34">
              <span className="inline-block mr-2" data-id="element-35">🌟</span> Lo Mejor de Todo
            </h3>
            <p className="text-lg font-medium text-amber-700 mb-6" data-id="element-36">
              Llevate Hoy Mismo el Pack Completo de Picadas Fáciles™
            </p>
            <p className="text-gray-700 mb-6" data-id="element-37">
              No necesitás experiencia previa en cocina. Con el Método Picadas
              Fáciles™, vas a seguir un sistema tan claro y probado que es
              prácticamente imposible fallar.
            </p>
            <p className="text-gray-700 font-medium mb-6" data-id="element-38">
              👉 Hacé clic en el botón de abajo y recibí acceso inmediato a todo
              el pack:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-39">
              <div className="flex items-center justify-center gap-2" data-id="element-40">
                <CheckEmoji size={18} className="text-green-600" data-id="element-41" />
                <span className="text-gray-700" data-id="element-42">Acceso inmediato en PDF</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-43">
                <CheckEmoji size={18} className="text-green-600" data-id="element-44" />
                <span className="text-gray-700" data-id="element-45">Sin experiencia previa</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-46">
                <CheckEmoji size={18} className="text-green-600" data-id="element-47" />
                <span className="text-gray-700" data-id="element-48">Resultados garantizados</span>
              </div>
            </div>
            <a href="#" className="checkout-fresh bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-all transform hover:scale-105 w-full text-center mb-6 inline-block" onClick={handleCheckout} data-id="element-49">
              👉 QUIERO MIS PICADAS FÁCILES AHORA - AR$17.990
            </a>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-50">
              <div className="flex items-center justify-center gap-2" data-id="element-51">
                <LockIcon size={16} className="text-amber-700" data-id="element-52" />
                <span className="text-gray-700 text-sm" data-id="element-53">Pago seguro</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-54">
                <LightningEmoji size={16} className="text-amber-700" data-id="element-55" />
                <span className="text-gray-700 text-sm" data-id="element-56">Entrega inmediata</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-57">
                <CheckEmoji size={16} className="text-amber-700" data-id="element-58" />
                <span className="text-gray-700 text-sm" data-id="element-59">Garantía 30 días</span>
              </div>
            </div>
          </div>
          <div className="mt-8 flex flex-col gap-4" data-id="element-60">
            <div className="flex items-center justify-center gap-2 text-gray-600" data-id="element-61">
              <LockIcon size={18} data-id="element-62" />
              <span data-id="element-63">Pago seguro: Visa, MasterCard, Mercado Pago</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-gray-600" data-id="element-64">
              <LightningEmoji size={18} className="text-gray-600" data-id="element-65" />
              <span data-id="element-66">Entrega inmediata por email</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}